import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {MatDatepicker} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from '@ngx-translate/core';
import { SheduleService } from "app/main/pagina/certificar/services/shedule.service";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import { ModalRecoComponent } from "./modal-reco/modal-reco.component";
import { SurveyCheckComponent } from "app/main/pagina/productos/certificar/tipo_1/programacion/vista-gen/survey-check/survey-check.component";
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
@Component({
  selector: 'vista-gen',
  templateUrl: './vista-gen.component.html',
  styleUrls: ['./vista-gen.component.scss'],
  animations   : fuseAnimations
})
export class VistaGenComponent implements OnInit {

  comunicacionCreacion: any;
  @Input() actualizaPaso: Observable<any>;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @Output() dataPiloto: EventEmitter<any> = new EventEmitter();
  // @Output() actualizaFlagCambios: EventEmitter<any> = new EventEmitter();
  @ViewChild('fecRecordatorio', { read: undefined }) calReco: MatDatepicker<Date>;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;

  idiomaActual:string;

  cards = catalogo.cards;
  secciones = catalogo.secciones;

  logoOK: boolean;
  reqTecOK: boolean;
  validarIzzi: boolean;

  idFechaLanzamiento: string;
  fechaLanzamiento: any;
  fechasRecordatorios: any[] = [];

  numSecciones = 0;
  seccionesCompletas = 0;
  indices:any[] = [];
  creandoEncuesta: boolean;
  tamanioTagSecc: number;
  progresoEncuesta = 0;
  procesoActual: string;
  procesoFinalizado: boolean;
  procesoOK = true;
  recrearEncuesta: boolean;
  seccionEncuesta: boolean;  //se usa para validacion del mensaje "encuesta creada"
  token:any;
  datosSurveyCheck:any;
  checarEncuesta:boolean=false;
  banderaRTV3:boolean=false;
  banderaBotonRTV3:boolean=false;

  filtroLanzamiento = (d: Date | null): boolean => {
    var moment = require('moment');
    return moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
  };
  filtroRecordatorios: any;
modalCambios:boolean=false;
  constructor(
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    private programacionService: ProgramacionService,
    private encuestaService: EncuestaService,
    private sheduleService: SheduleService,
    private wizardService: WizardService,
    private odsService: ODSService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    this.programacionService.ordenProg.subscribe( (resu) => {
      console.log("se envio orden desde navbar: ",resu);
      this.logoOK = true;
      if(this.logoOK && this.reqTecOK){
        this.cards[0].completo = true;
      }
    });

    if(localStorage.getItem('tipoIzzi')){
      this.validarIzzi=true;
    }
  }

  ngOnInit() {
    this.obtieneCertificarActual();
    // this.getFechaLanzamiento();
    this.getestatusSecciones();
    // this.getEstatusEncuesta();
    this.getEstatusEncuestaNuevo();
    this.prerequisitos();
    this.comunicacionCreacion = this.actualizaPaso.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);

      this.getStatusSeccion();
    });
  }

  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
  }

  cargaLogoEmpresa(){
    console.log("se hizo clic al boton img");
    this.programacionService.enviaNavbar("hola prro");
  }

  preCrearEncuesta(){
    if(this.logoOK && this.reqTecOK){
      let texto = "SHEDULE2_0.MODALES.ENCUESTA.CREAR_3";
      // let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
      let rspSi = 'MODALES.ACCIONES.aceptar';
      let rspNo = 'MODALES.ACCIONES.cancelar';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.crearEncuesta();
          // this.crearEncuestaBack();
        }
      });
    }
    else{
      if(!this.logoOK){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.SUBIRLOGO'),3);
      }
      else if(!this.reqTecOK){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'),3);
      }
    }
  }

  crearEncuestaBack(){
    this.reiniciarVariables();
    this.secciones.forEach((seccion,i) => {
      if(seccion.visible){
        this.numSecciones++;
        this.indices.push(i);
      }
    });
    this.tamanioTagSecc = 100 / this.numSecciones;
    console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);

    this.creandoEncuesta = true;
    this.procesoActual = this.secciones[0].proceso;

    //seccion error
    let secErr = Math.floor(Math.random() * (this.numSecciones - 1 + 1)) + 1;
    let esperaImg = setInterval(() => {
      this.procesoActual = "";

      if(this.seccionesCompletas == this.numSecciones){
        this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
        setTimeout(() => {
          this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
        }, 200);
        console.log("secciones completas:",this.seccionesCompletas," | progreso:",this.progresoEncuesta);
        clearInterval(esperaImg);
        this.procesoFinalizado = true;
      }
      else{
        if(this.seccionesCompletas == 0){
          this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
        }
        else{
          this.progresoEncuesta += this.tamanioTagSecc;
        }
        //prueba de una seccion con fallo
        if(this.seccionesCompletas == secErr){
          this.secciones[this.indices[this.seccionesCompletas]].fallo = true;
          // if(this.secciones[this.indices[this.seccionesCompletas+1]]){
            setTimeout(() => {
              this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].error;
            }, 200);
          // }
          clearInterval(esperaImg);
          this.procesoFinalizado = true;
          this.procesoOK = false;
        }
        else{
          this.secciones[this.indices[this.seccionesCompletas]].completo = true;
          if(this.secciones[this.indices[this.seccionesCompletas+1]]){
            setTimeout(() => {
              this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].proceso;
            }, 200);
          }
          else{
            setTimeout(() => {
              this.procesoActual = "SHEDULE2_0.SECCIONES.DETALLES";
            }, 200);
          }
          this.seccionesCompletas++;
          console.log("secciones completas:",this.seccionesCompletas," | progreso:",this.progresoEncuesta);
        }

      }
		}, 2000);
  }

  reiniciarVariables(){
    this.secciones.forEach(seccion => {
      seccion.completo = false;
      seccion.fallo = false;
    });
    this.tamanioTagSecc = 0;
    this.progresoEncuesta = 0;
    this.procesoActual = "";
    this.procesoFinalizado = false;
    this.procesoOK = true;
  }

  traduceTextosTS(){
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.encuestaService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.token=producto.tokenConfig;
              // this.modalCambios=producto.modalCambios;
              // this.surveyCheckService(this.token);
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      // this.encuestaService.getStatusProgramacion(parseInt(localStorage.getItem('fechaProducto'))).subscribe( (data: backInter.getStatusIndiv) => {
      //   if(data.estatus === 3)
      //     this.pasoCompleto = true;
      // });
      // this.getStatusModal();
      this.getStatusSeccion();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusSeccion(){
    this.encuestaService.getStatusEncuesta(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
      if(data.estatus === 3){
        this.pasoCompleto = true;
      }else{
        this.pasoCompleto = false;
      }

      console.log("Paso completo "+this.pasoCompleto);
    });
  }

  getStatusModal(){
    let datos={
      productoId: parseInt(localStorage.getItem('productoID')),
      programacion: 1
    };
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
        this.modalInformativo('PROGRAMACION');
      }
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      inputValidator: (result)=>{
        return new Promise((resolve)=>{
          if (result){
            this.updateStatusModal();
          }
          resolve(result);
        });
      },
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    })
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      programacion: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getPilotoDataEncuesta(){
    let data={
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getPilotoDataEncuesta(data).subscribe((data: backInter.getEncuestaPilotoC2) => {
      console.log("getPilotoData:",data);
      if(data.message= "Success"){
        //envia los datos del piloto al componente padre
        if(data.piloto.usuariosTest.length > 1){
          this.recrearEncuesta=true;
        }
        this.dataPiloto.emit({
          data,
          procesoFinalizado: this.procesoFinalizado,
          productoCertificar: this.productoCertificar
        });
        // this.flag = true;
      }else{
        // this.flag = false;
      }

    });
  }

  getestatusSecciones(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.encuestaService.getStatusSecciones(data).subscribe((response:any) => {
      console.log("respGetSecc",response);
      this.secciones.forEach(seccion => {
        var BreakException = {};
        try {
          response.secciones.forEach( (seccionAgregada) => {
            if(seccion.id == seccionAgregada.nombre){
              seccion.visible = seccionAgregada.estatus;
              // console.log("coinciden:",seccion,"| respuesta:",seccionAgregada);
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
      });
      console.log("Secciones Tras filtro:",this.secciones);

    }, error => {
      console.log(error);
    });
  }

  getEstatusEncuesta(){
    let data = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getEstatusEncuesta(data).subscribe((respuesta: backInter.getEstatusEncuesta) => {
      console.log("getStatEnc",respuesta);

      if(respuesta.success){
        console.log("encuesta anterior");
        if(respuesta.survey){
          this.seccionEncuesta = respuesta.survey;
          this.procesoFinalizado = true;
          this.procesoOK = true;
          this.progresoEncuesta = 100;
          this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
          this.secciones.forEach(seccion => {
            seccion.completo = true;
            switch (seccion.id) {
              case 'NPS':
              seccion.visible = respuesta.nps;
              break;
              case 'Reactivos':
              seccion.visible = respuesta.reactivos;
              break;
              case 'Control':
              seccion.visible = respuesta.control;
              break;
              case 'Demograficos':
              seccion.visible = respuesta.demograficos;
              break;
              case 'Abiertas':
              seccion.visible = respuesta.abiertas;
              break;
              case 'Forall':
              seccion.visible = respuesta.forall;
              break;
              case 'Adicionales':
              seccion.visible = respuesta.adicionales;
              break;
            }
          });
        }
      }
      this.getPilotoDataEncuesta();
    }, error => {
      console.log(error);
    });
  }

  getEstatusEncuestaNuevo(){
    this.encuestaService.getEstatusEncuesta2().subscribe((respuesta: any) => {
      console.log("getStatEnc2",respuesta);

      if(respuesta.newproduct){
        console.log("encuesta nueva");
        let encuestaOk = true;
        this.seccionEncuesta = respuesta.survey;
        this.recrearEncuesta = respuesta.recreateSurvey;
        this.secciones.forEach(seccion => {
          switch (seccion.id) {
            case 'encuesta':
              seccion.visible = true;
              seccion.completo = respuesta.survey;
            break;
            case 'usuarios':
              seccion.visible = true;
              seccion.completo = true;
            break;
            case 'NPS': case 'Reactivos': case 'Control': case 'Demograficos': case 'Abiertas': case 'Forall': case 'Adicionales':
              let indice = respuesta.secciones.findIndex(item => item.nombre == seccion.id);
              if(indice != -1){
                seccion.visible = respuesta.secciones[indice].estatus;
                seccion.completo = respuesta.secciones[indice].insurvey && respuesta.secciones[indice].questions;
              }
            break;
          }
          if(seccion.visible && !seccion.completo){
            encuestaOk = false;
          }
        });
        if(encuestaOk){
          this.procesoFinalizado = true;
          this.checarEncuesta=true;
          this.procesoOK = true;
          this.progresoEncuesta = 100;
          this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
        }
        this.getPilotoDataEncuesta();
      }
      else{
        this.getEstatusEncuesta();
      }

    }, error => {
      console.log(error);
    });
  }

  prerequisitos(){
    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {
      console.log("getPreReq",respuesta);
      // if(respuesta.success){
      //   this.logoOK = respuesta.logo;
      //   this.reqTecOK = respuesta.requerimientos || this.validarIzzi;
      //
      //   if(respuesta.requerimientosv3.autentication==true && respuesta.requerimientosv3.requirements==true &&
      //   respuesta.requerimientosv3.testAccess==true && respuesta.requerimientosv3.testEmail==true &&
      //   respuesta.requerimientosv3.validationQ==true){
      //     this.banderaRTV3=true;
      //   }
      //   else{
      //     this.banderaRTV3=false;
      //   }
      //
      //   if(this.banderaRTV3 || this.reqTecOK){
      //     this.banderaBotonRTV3=true;
      //   }
      //
      //   if((this.banderaRTV3 || this.reqTecOK) && this.logoOK){
      //     this.cards[0].completo = true;
      //   }
      // }
      if(respuesta.success){
        this.logoOK = respuesta.logo;
        this.reqTecOK = respuesta.requerimientos || this.validarIzzi;
        if(this.logoOK && this.reqTecOK){
          this.cards[0].completo = true;
        }
      }
    }, error => {
      console.log(error);
    });
  }

  verSeccionesAgregadas(){
    this.creandoEncuesta = !this.creandoEncuesta;
  }

  crearEncuesta(){
    this.reiniciarVariables();
    this.secciones.forEach((seccion,i) => {
      if(seccion.visible){
        this.numSecciones++;
        this.indices.push(i);
      }
    });
    this.tamanioTagSecc = 100 / this.numSecciones;
    console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);

    this.creandoEncuesta = true;
    this.procesoActual = this.secciones[0].proceso;


    if(this.seccionEncuesta){
      let data = {
        productoId: localStorage.getItem('productoID'),
        recreateSurvey: true
      };
      this.pasoEncuesta(data);
    }else if(this.recrearEncuesta){
      let data = {
        productoId: localStorage.getItem('productoID'),
        recreateSurvey: true
      };
      this.pasoEncuesta(data);
    }else{
      let data = {
        productoId: localStorage.getItem('productoID'),
        recreateSurvey: false
      };
      this.pasoEncuesta(data);
      console.log("Es la primera vez");
    }
    //this.pasoEncuesta(data);
  }
  //PASOS CREACION DE ENCUESTA

  pasoEncuesta(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.crearEncuesta2(data).subscribe((respuesta:any) => {
      console.log("pasoEncuesta:",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.pasoUsuarios(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoUsuarios(data:any){
    this.sumaProgresoProceso();
    this.encuestaService.saveUsuarios(data).subscribe((respuesta:any) => {
      console.log('pasoUsuarios',respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoNPS(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      seccion:1
    };
    this.encuestaService.saveNPSCONTROL(data1).subscribe((respuesta:any) => {
      console.log('pasoNPS',respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoReactivos(data:any){
    this.sumaProgresoProceso();
    let dataProv: any;
    if(this.seccionEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else if(this.recrearEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else{
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: false
      };
    }
    this.encuestaService.saveReactivos(dataProv).subscribe((respuesta:any) => {
      console.log('pasoReactivos',respuesta);
      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoControl(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      seccion:3
    };
    this.encuestaService.saveNPSCONTROL(data1).subscribe((respuesta:any) => {
      console.log("pasoControl",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoDemograficos(data:any){
    this.sumaProgresoProceso();
    let dataProv: any;
    if(this.seccionEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else if(this.recrearEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else{
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: false
      };
    }
    this.encuestaService.saveDemograficos(dataProv).subscribe((respuesta:any) => {
      console.log("pasoDemograficos",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoAdicionales(data:any){
    this.sumaProgresoProceso();
    let dataProv: any;
    if(this.seccionEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else if(this.recrearEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else{
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: false
      };
    }
    this.encuestaService.saveAdicionales(dataProv).subscribe((respuesta:any) => {
      console.log("pasoAdicionales",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoForall(data:any){
    this.sumaProgresoProceso();
    let dataProv: any;
    if(this.seccionEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else if(this.recrearEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else{
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: false
      };
    }
    this.encuestaService.saveForall(dataProv).subscribe((respuesta:any) => {
      console.log("pasoForall",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoAbiertas(data:any){
    this.sumaProgresoProceso();
    let dataProv: any;
    if(this.seccionEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else if(this.recrearEncuesta){
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: true
      };
    }else{
      dataProv = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        recreateSurvey: false
      };
    }
    this.encuestaService.saveAbiertas(dataProv).subscribe((respuesta:any) => {
      console.log("pasoAbiertas",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  sumaProgresoProceso(){
    if(this.seccionesCompletas == 0){
      this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
    }
    else{
      this.progresoEncuesta += this.tamanioTagSecc;
    }
  }

  pasoCorrecto(){
    this.secciones[this.indices[this.seccionesCompletas]].completo = true;
    if(this.secciones[this.indices[this.seccionesCompletas+1]]){
      setTimeout(() => {
        this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].proceso;
      }, 200);
    }
    else{
      setTimeout(() => {
        this.procesoActual = "SHEDULE2_0.SECCIONES.DETALLES";
      }, 200);
    }
    this.seccionesCompletas++;
    this.checkFinProceso();
  }

  siguientePaso(data:any){
    if(this.indices[this.seccionesCompletas]){
      switch (this.secciones[this.indices[this.seccionesCompletas]].id) {
        case 'NPS': this.pasoNPS(data); break;
        case 'Reactivos': this.pasoReactivos(data); break;
        case 'Control': this.pasoControl(data); break;
        case 'Demograficos': this.pasoDemograficos(data); break;
        case 'Abiertas': this.pasoAbiertas(data); break;
        case 'Forall': this.pasoForall(data); break;
        case 'Adicionales': this.pasoAdicionales(data); break;
      }
    }
  }

  pasoFallido(){
    this.secciones[this.indices[this.seccionesCompletas]].fallo = true;
    setTimeout(() => {
      this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].error;
    }, 200);
    this.procesoFinalizado = true;
    this.procesoOK = false;
  }

  checkFinProceso(){
    if(this.seccionesCompletas == this.numSecciones){
      this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
      setTimeout(() => {
        this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
        this.getPilotoDataEncuesta();
      }, 200);
      this.procesoFinalizado = true;
      this.recrearEncuesta = true;
      this.seccionEncuesta = true;
      this.checarEncuesta=true;
      this.obtieneCertificarActual();
      // if (this.modalCambios) {
      //   let datos={
      //     modalFlag:false,
      //   }
      //   this.odsService.updateFlagCambios(localStorage.getItem('companyID'),localStorage.getItem('productoID'),datos).subscribe(response => {
      //     console.log(response);
      //
      //     this.actualizaFlagCambios.emit(true);
      //   }, error => {
      //           console.log(error);
      //         });
      // }
    }
  }

  surveyCheckService(){
    this.programacionService.surveyCheck(this.token).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.datosSurveyCheck=respuesta.result;
      this.surveyCheck();
    }, error => {
    });
  }

  surveyCheck(){
      const dialogRef = this.dialog.open(SurveyCheckComponent, {
        width: '40%',
        data: {
          datos: this.datosSurveyCheck
        }
      });
  }

}
